<!-- Canvas image and action buttons -->
<div id="mapContainer" class="map-container">
  <div [ngClass]="{'canvasBlockWidth': !isEditMode}" *ngIf="!mapLoading">
    <!-- Address -->
    <div class="d-flex mr-3">
      <label class="pt-0 mr-2">Address: </label>
      <div>{{locationInfo.ADDRESS}}</div>
    </div>
    <div class="d-flex">
      <div class="d-flex mr-3">
        <label class="pt-0 mr-2">Zip: </label>
        <div>{{locationInfo.ZIP}}</div>
      </div>
      <div class="d-flex mr-3">
        <label class="pt-0 mr-2">City: </label>
        <div>{{locationInfo.CITY}}</div>
      </div>
      <div class="d-flex">
        <label class="pt-0 mr-2">State: </label>
        <div>{{commonService.getStateName(locationInfo.STATE)}}</div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="canvasBlockWidth paddingLeftZero">

      <!-- Canvas mode -->
      <div class="{{mode === 'locate' ? 'd-none' : 'd-inline-block'}}">
        <!-- Canvas -->
        <div class="canvas-cont" [hidden]="isCropMode || mapLoading">
          <canvas width="600" height="428" class="mapCanvas" id="mapCanvas{{index}}"></canvas>
        </div>

        <!-- Loading bar -->
        <app-loader [loading]="mapLoading"></app-loader>

        <!-- Crop image -->
        <div [hidden]="!isCropMode" style="display: inline-block;">
          <angular-cropper #angularCropper1 [cropperOptions]="cropConfig" imageUrl="{{mapImage}}"></angular-cropper>
        </div>
      </div>

      <!-- Locate mode -->
      <div class="{{mode === 'draw' ? 'd-none' : 'd-inline-block'}}">
        <div class="mapCanvas" id="locate-view{{index}}"></div>
      </div>

      <!-- New Action buttons -->
      <div class="horizontalToolbar" *ngIf="isEditMode">
        <!-- First Row (Locate Mode)-->
        <div *ngIf="mode === 'locate'">
          <button class="map-action-button mapAction toggleButton" (click)="changeMode()" title="Change Mode"><i class="fa fa-retweet"></i></button>
        </div>

        <!-- Toolbar -->
        <div class="row toolbar-container" *ngIf="mode === 'draw'">
          <!-- Position -->
          <div class="col-4 p-0 section">
            <div class="section-name">Position</div>
            <div class="d-flex flex-wrap">
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="moveLeft()"><i class="fa fa-arrow-left"></i></button>
                <div class="hint">Move map to the left</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="moveRight()"><i class="fa fa-arrow-right"></i></button>
                <div class="hint">Move map to the right</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="zoomIn()"><i class="fa fa-plus"></i></button>
                <div class="hint">Zoom in over the map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="zoomOut()"><i class="fa fa-minus"></i></button>
                <div class="hint">Zoom out over the map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="moveTop()"><i class="fa fa-arrow-up"></i></button>
                <div class="hint">Move map to the top</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="moveDown()"><i class="fa fa-arrow-down"></i></button>
                <div class="hint">Move map to the down</div>
              </div>
            </div>
          </div>

          <!-- Draw -->
          <div class="col-4 pl-2 pr-0 section">
            <div class="section-name">Draw</div>
            <div class="d-flex flex-wrap">
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.addTextToCanvas(canvas)"><i class="fa fa-font"></i></button>
                <div class="hint">Add Text on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.addCircleToCanvas(canvas, shapeBorderColor, shapeStroke, shapeStrokeWidth)">
                  <i class="fa fa-circle-o"></i>
                </button>
                <div class="hint">Add Circle on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction squareIcon" (click)="canvasService.addRectangleToCanvas(canvas, shapeBorderColor, shapeStroke, shapeStrokeWidth)"><i class="fa fa-square-o"></i></button>
                <div class="hint">Add Square on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.addArrowToCanvas(canvas, shapeStroke, shapeStrokeWidth)"><i class="fa fa-long-arrow-right rotate225"></i></button>
                <div class="hint">Add Arrow on map</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.fillColor(canvas, shapeFillColor)"><i class="fa fa-paint-brush"></i></button>
                <div class="hint">Fill Shape with Color</div>
              </div>

              <div class="hinted relative">
                <div class="btn-group" dropdown>
                    <button dropdownToggle type="button" class="map-action-button mapAction dropdown-toggle">
                        <hr class="shapeButtonBorder">
                    </button>
                    <ul *dropdownMenu class="borderDropdown dropdown-menu" role="menu">
                        <li role="menuitem" (click)="selectShapeBorderWidth(1)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border1"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(2)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border2"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(3)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border3"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(4)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border4"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(5)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border5"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(6)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border6"></a></li>
                        <li role="menuitem" (click)="selectShapeBorderWidth(7)"><a class="borderDropdownItem dropdown-item"><hr class="shape-border border7"></a></li>
                    </ul>
                </div>
                <div class="hint">Select width of border</div>
              </div>

              <div class="hinted relative">
                <input class="color-picker-input" [style.background]="shapeFillColor" [(colorPicker)]="shapeFillColor" (colorPickerOpen)="canvasService.changeFillColor('colorPickerOpen', $event, canvas, shapeFillColor)" (colorPickerClose)="canvasService.changeFillColor('colorPickerClose', $event, canvas, shapeFillColor)" (cpInputChange)="canvasService.changeFillColor('cpInputChange', $event, canvas, shapeFillColor)" (cpSliderDragStart)="canvasService.changeFillColor('cpSliderDragStart', $event, canvas, shapeFillColor)" (cpSliderDragEnd)="canvasService.changeFillColor('cpSliderDragEnd', $event, canvas, shapeFillColor)"/>
                <div class="hint">Select background color for drawing item</div>
              </div>

              <div class="hinted relative">
                <input class="color-picker-input" [style.background]="shapeStroke" [(colorPicker)]="shapeStroke" (colorPickerOpen)="canvasService.changeBorderColor('colorPickerOpen', $event, canvas, shapeStroke)" (colorPickerClose)="canvasService.changeBorderColor('colorPickerClose', $event, canvas, shapeStroke)" (cpInputChange)="canvasService.changeBorderColor('cpInputChange', $event, canvas, shapeStroke)" (cpSliderDragStart)="canvasService.changeBorderColor('cpSliderDragStart', $event, canvas, shapeStroke)" (cpSliderDragEnd)="canvasService.changeBorderColor('cpSliderDragEnd', $event, canvas, shapeStroke)"/>
                <div class="hint">Select color of border</div>
              </div>

              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="canvasService.removeObject(canvas)"><i class="fa fa-trash"></i></button>
                <div class="hint">Remove Selected Shape</div>
              </div>
            </div>
          </div>

          <!-- Edit -->
          <div class="col-4 pl-2 pr-0 section">
            <div class="section-name">Manipulate</div>
            <div class="d-flex">
              <div class="hinted relative">
                <button class="{{isShowAnimation ? 'animated-button' : 'mode-toggle'}} map-action-button mapAction" (click)="changeMode()"><i class="fa fa-retweet"></i></button>
                <div class="hint">Change viewing mode of the map</div>
              </div>
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="cropAnImage()"><i class="fa {{isCropMode ? 'fa-check' : 'fa-crop'}}"></i></button>
                <div class="hint">Apply crop on existing image</div>
              </div>
              <div class="hinted relative">
                <button class="map-action-button mapAction" (click)="changeMapView()"><i class="fa fa-street-view"></i></button>
                <div class="hint">Change to the street view</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Search + List + No list message -->
    <div class="paddingZero marginLeft10" [hidden]="!isEditMode || mode === 'locate'" style="width: calc(100% - 615px);">
      <!-- Search inputs in a given city -->
      <div class="form-group marginBottom10">
          <input type="text" class="form-control" placeholder="search" [(ngModel)]="searchValue"
              id="place-search{{index}}" />
      </div>

      <!-- Places list -->
      <div class="boxBorder" *ngIf="placesList?.length > 0 && !showSearchloading">
        <div *ngFor="let place of placesList; let i=index;" class="centerBtn placeList"
        (click)="getPlaceDetailAndCreateMarker(i)">
          <!-- Button to make place center according to this place -->
          <!-- <button class="btn btn-rbv marginRight10"  type="button">
            <i class="fa fa-map-marker"></i>
          </button> -->
          <img class="place-icon" *ngIf="place.IMAGE" [src]="place.IMAGE" alt="Marker Image"
            (click)="makeMapCenterForThisPlace(place);preventClick($event);"/>

          <div [ngClass]="{'opacityHalf': place.IS_MARKED}">
            <div class="placeName">{{place.PLACE.name}}</div>
            <div class="placeAddress">{{place.PLACE.formatted_address}}</div>
            <div class="addPlaceIcon"><i class="fa {{place.IS_MARKED ? 'fa-minus' : 'fa-plus'}}"></i></div>
          </div>
        </div>
      </div>

      <!-- Loading for place list -->
      <div *ngIf="showSearchloading" class="textCenter">
          <span class="loading-icon-small"></span>
      </div>

      <!-- No places found message -->
      <div *ngIf="placesList?.length === 0 && !showSearchloading" class="noListMessage">
          No places found
      </div>
    </div>
  </div>
</div>
